import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AppState } from 'src/store/store';
import { PassengerTypesPageState } from 'src/pages/passengerTypes/types';
import guidesApiService from 'src/api/services/guidesApiService';
import { notification } from 'antd';

const initialState: PassengerTypesPageState = {
    isLoading: false,
    items: [],
    requestId: ''
};

export const loadPassengerTypesAsync = createAsyncThunk('passengerTypes/load', async () => {
    try {
        const data = await guidesApiService.getPassengerTypes();
        return data;
    } catch (error) {
        if (error instanceof Error) {
            notification.error({ message: error.message });
        }
        throw new Error();
    }
});

const slice = createSlice({
    name: 'passengerTypes',
    initialState,
    reducers: {
        reset: () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadPassengerTypesAsync.pending, (state, action) => {
                state.isLoading = true;
                state.items = [];
                state.requestId = action.meta.requestId;
            })
            .addCase(loadPassengerTypesAsync.fulfilled, (state, action) => {
                if (state.requestId === action.meta.requestId) {
                    state.isLoading = false;
                    state.items = action.payload;
                }
            })
            .addCase(loadPassengerTypesAsync.rejected, (state, action) => {
                if (state.requestId === action.meta.requestId) {
                    state.isLoading = false;
                }
            });
    }
});

export const { reset } = slice.actions;

const selectPassengerTypes = (state: AppState) => state.passengerTypes;

export const selectItems = (state: AppState) => selectPassengerTypes(state).items;

export const selectIsLoading = (state: AppState) => selectPassengerTypes(state).isLoading;

export default slice.reducer;
